import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { maxHeight } from "styled-system";
import { Block, Divider, Tabs } from "reakit";
import { Box, Card, Flex, Image, Text } from "rebass";
import { TabHeader } from "../Base";
import { schoolActions, schoolSelectors } from "../../store/school";
import { authActions, authSelectors } from "../../store/auth";
import { searchFacultyActions, searchFacultySelectors } from "../../store/searchFaculty";
import check from "../../resources/img/icons/Checkbox@1x-black.png";
import styled from "styled-components";

const textProps = {
	ml: 3
};

/* icon imports */
const PanelWrapper = styled(Card)`
	max-height: calc(45vh - 65px);
   overflow-x: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
  ${maxHeight}
`;

PanelWrapper.defaultProps = {
	maxHeight: ['calc(100vh - 145px)', 'calc(45vh - 65px)']
};

// This is the original Filter component first used on the Search page
class Filters extends Component {

	state = {
		grade: [],
		dorm: [],
		gender: [],
		locations: [],
		interests: [],
		filters: {
			interests: [],
			grade: [],
			location: [],
			dorm: [],
			gender: [],
			type: []
		},
		selectAll: {
			grade: false,
			dorm: false,
			gender: false,
			type: false,
			location: false
		},
	};

	componentDidMount() {
		const { isCheckin, filters, extraCheckinFilters } = this.props;
		if (!isCheckin) {
			this.setState({
				filters: filters,
			})
		} else {
			if (extraCheckinFilters) {
				this.setState({ filters: extraCheckinFilters })
			}
		}
	}

	handleSelect = (name, index) => {
		const { filters } = this.state;
		let newFilters = filters;
		let filter = filters[index];
		let contains = false;
		for (var i = filter.length - 1; i >= 0; i--) {
			if (filter[i] === name) {
				filter.splice(i, 1);
				contains = true;

				newFilters[index] = filter
			}
		}

		if (!contains) {
			filter.push(name);
			newFilters[index] = filter
		}
		this.setState({ filters: newFilters });

		this.handleUpdate(newFilters)


	};

	handleUpdate = (filters) => {
		const { handleUpdate } = this.props;
		handleUpdate(filters)
  }

	handleSelectAll = (all, index) => {
		const { filters, selectAll } = this.state;
		const { isCheckin, checkinFilters } = this.props;

		// new state starts here
		let newFilters = filters;
		let newSelectAll = selectAll

		let filter = filters[index];
		if (all.length === filter.length || selectAll[index] === true) {
			filter = []
			newSelectAll[index] = false

		} else {
			if (isCheckin === true) {
				const lockedFilter = checkinFilters[index]
				filter = all.filter(val => !lockedFilter.includes(val))
				newSelectAll[index] = true
			} else {
				filter = all
				newSelectAll[index] = true

			}
		}

		newFilters[index] = filter
		this.setState({ filters: newFilters, selectAll: newSelectAll })
		this.handleUpdate(newFilters)
	}

	componentWillReceiveProps(nextProps, nextContext) {
		if (nextProps.isCheckin === true && nextProps.extraCheckinFilters !== this.props.extraCheckinFilters) {
			this.setState({ filters: nextProps.extraCheckinFilters })
		} else if (nextProps.filters !== this.props.filters) {
			this.setState({ filters: nextProps.filters })
		}

	}

	renderSelectAll = (all, index) => {
		const { selectAll } = this.state;

		const selected = selectAll[index]
		return (
			<Box width={1}>
				<Flex justifyContent={'flex-start'} flexWrap={'wrap'} pt={2} pb={3}>
					<Text ml={3} color='blue'
						onClick={() => this.handleSelectAll(all, index)}>{selected ? 'Unselect All' : 'Select All'}</Text>
				</Flex>
			</Box>
		)
	}

	render() {
		const { filters } = this.state;
		const { isLoading, isCheckin, checkinFilters } = this.props;

		return (
			<Tabs.Container>
				{tabs => (
					<Block maxHeight={'45vh'} fontWeight={600}>
						<Flex>
							<Tabs width={'100%'}>
								<Tabs.Tab padding={'15px'} tab="gender" {...tabs}><TabHeader title={'Gender'} /></Tabs.Tab>
								<Tabs.Tab padding={'15px'} tab="type" {...tabs}><TabHeader title={'Type'} /></Tabs.Tab>
							</Tabs>
						</Flex>
						{!isLoading &&
							<Fragment>
								<Tabs.Panel tab="gender" {...tabs}>
									<Card mt={'15px'} px={2}>

										{this.renderSelectAll(['M', 'F'], 'gender')}
										<Box width={1}>
											<Flex
												onClick={isCheckin && checkinFilters.gender && checkinFilters.gender.includes('F') ? () => console.log('check filter') : () => this.handleSelect('F', 'gender')}>
												<Box>
													<Text {...textProps} name='male'>Female</Text>
												</Box>
												<Box ml={'auto'} />
												<Box pr={2}>

													{isCheckin && checkinFilters.gender && checkinFilters.gender.includes('F') ?
														<Image src={check} /> : filters.gender.includes('F') && <Image src={check} />}
												</Box>
											</Flex>

										</Box>

										<Box width={1}>
											<Divider />
										</Box>

										<Flex
											onClick={isCheckin && checkinFilters.gender && checkinFilters.gender.includes('M') ? () => console.log('check filter') : () => this.handleSelect('M', 'gender')}>
											<Box>
												<Text {...textProps} name='male'>Male</Text>
											</Box>
											<Box ml={'auto'} />
											<Box pr={2}>
												{isCheckin && checkinFilters.gender && checkinFilters.gender.includes('M') ?
													<Image src={check} /> : filters.gender.includes('M') && <Image src={check} />}
											</Box>
										</Flex>
										<Divider />

									</Card>
								</Tabs.Panel>

								<Tabs.Panel tab="type" {...tabs}>
									<Card mt={'15px'} px={2}>
										<Box width={1}>
											<Flex
												onClick={
                          isCheckin && checkinFilters.type && checkinFilters.type.includes('S') ?
                            () => console.log('check filter') :
                            () =>  {
                              if (filters.type.includes('E')) {
                                this.handleSelect('E', 'type');
                              }
                              this.handleSelect('S', 'type')
                            }
                        }>
												<Box>
													<Text {...textProps} name='staff'>Staff</Text>
												</Box>
												<Box ml={'auto'} />
												<Box pr={2}>
													{isCheckin && checkinFilters.type && checkinFilters.type.includes('S') ?
														<Image src={check} /> : filters.type && filters.type.includes('S') && <Image src={check} />}
												</Box>
											</Flex>

										</Box>

										<Box width={1}>
											<Divider />
										</Box>

										<Flex
											onClick={
                        isCheckin && checkinFilters.type && checkinFilters.type.includes('E') ?
                          () => console.log('check filter') :
                          () => {
                            if (filters.type.includes('S')) {
                              this.handleSelect('S', 'type');
                            }
                            this.handleSelect('E', 'type')
                          }
                      }>
											<Box>
												<Text {...textProps} name='employee'>Employee</Text>
											</Box>
											<Box ml={'auto'} />
											<Box pr={2}>
												{isCheckin && checkinFilters.type && checkinFilters.type.includes('E') ?
													<Image src={check} /> : filters.type && filters.type.includes('E') && <Image src={check} />}
											</Box>
										</Flex>
										<Divider />

									</Card>
								</Tabs.Panel>
							</Fragment>}
					</Block>
				)}
			</Tabs.Container>
		);
	}
}

Filters.propTypes = {
	dormView: PropTypes.bool,
	isCheckin: PropTypes.bool,
	noLocation: PropTypes.bool
};

Filters.defaultProps = {
	dormView: false,
	isCheckin: false,
	noLocation: false
};

const mapStateToProps = (state) => ({
	schoolInfo: schoolSelectors.refreshSchool(state.school),
	profileInfo: authSelectors.refreshProfile(state.auth),
	loading: authSelectors.isLoading(state.auth),
	filters: searchFacultySelectors.refreshFilters(state.searchFaculty),
	isLoading: schoolSelectors.isLoading(state.school),
});

const mapDispatchToProps = (dispatch) => ({
	updateSchoolInfo: (data) => {
		dispatch(schoolActions.updateSchoolInfo(data))
	},
	updateProfileInfo: (data) => {
		dispatch(authActions.updateProfileInfo(data))
	},
	handleUpdate: (filters) => {
		dispatch(searchFacultyActions.updateFilter(filters))
	},
});


export default connect(() => (mapStateToProps), mapDispatchToProps)(Filters);
